module.exports = __webpack_public_path__ + "img/sphere_global.7e40efde.png";